import { render } from "./AdmissionOverviewCard.vue?vue&type=template&id=027791ab&scoped=true"
import script from "./AdmissionOverviewCard.vue?vue&type=script&lang=js"
export * from "./AdmissionOverviewCard.vue?vue&type=script&lang=js"

import "./AdmissionOverviewCard.vue?vue&type=style&index=0&id=027791ab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027791ab"]])

export default __exports__